import { useStyles } from "@webapps/styles";
import { useEffect, useRef, useState } from "react";
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';
import Avatar from '@material-ui/core/Avatar';
import ClassiqueHeader from "./ClassiqueCopyHeader";
import ClassiqueCopyHeader from "./ClassiqueCopyHeader";
import CakeIcon from "pages/student/Cv/Icons/Cake";
import PhoneIcon from "pages/student/Cv/Icons/Phone";
import MailIcon from "pages/student/Cv/Icons/Mail";
import LocationIcon from "pages/student/Cv/Icons/Location";
import { differenceInYears } from 'date-fns';
import { formatPhoneNumber } from 'react-phone-number-input';

function useWindowSize() {
  const [windowSize, setWindowSize] = useState({
    widthScreen: window.innerWidth,
    heightScreen: window.innerHeight,
  });

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        widthScreen: window.innerWidth,
        heightScreen: window.innerHeight,
      });
    }

    window.addEventListener('resize', handleResize);

    // Cleanup pour éviter les fuites mémoire
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowSize;
}

const getWindowsSize = () => {
  const { widthScreen, heightScreen } = useWindowSize();
  return { widthScreen, heightScreen };
};

const percentage = {
  percentageThemeChoise: 0.15,
  percentageSettings: 0.2,
  percentageContent: 1 - 0.15 - 0.20
}

const colorsTheme = [
  {
    name: "grey",
    colorHeader: "#333",
    colorSidebar: "#777",
    colorContent: "#FFFFFF",
    colorTextHeader: "#fff",
    colorTextSidebar: "#ccc",
  },
  {
    name: "blue",
    colorHeader: "#1E3A8A", // Bleu profond
    colorSidebar: "#2563EB", // Bleu vif
    colorContent: "#FFFFFF",
    colorTextHeader: "#FFFFFF", // Blanc
    colorTextSidebar: "#F0F8FF", // Blanc légèrement bleu
    colorTextContent: "#1A202C", // Noir légèrement bleuté
  },
  {
    name: "red",
    colorHeader: "#B91C1C", // Rouge intense
    colorSidebar: "#EF4444", // Rouge vif
    colorContent: "#FFFFFF",
    colorTextHeader: "#FFFFFF", // Blanc
    colorTextSidebar: "#FFEBEE", // Blanc légèrement rosé
    colorTextContent: "#2C1A1A", // Noir légèrement rouge
  },
  {
    name: "green",
    colorHeader: "#047857", // Vert profond
    colorSidebar: "#10B981", // Vert vif
    colorContent: "#FFFFFF",
    colorTextHeader: "#FFFFFF", // Blanc
    colorTextSidebar: "#E6FFFA", // Blanc légèrement vert
    colorTextContent: "#1A2C20", // Noir légèrement vert
  },
  {
    name: "purple",
    colorHeader: "#7C3AED", // Violet profond
    colorSidebar: "#A78BFA", // Violet vif
    colorContent: "#FFFFFF",
    colorTextHeader: "#FFFFFF", // Blanc
    colorTextSidebar: "#F5F3FF", // Blanc légèrement violet
    colorTextContent: "#241A2C", // Noir légèrement violet
  },
  {
    name: "orange",
    colorHeader: "#D97706", // Orange profond
    colorSidebar: "#F59E0B", // Orange vif
    colorContent: "#FFFFFF",
    colorTextHeader: "#FFFFFF", // Blanc
    colorTextSidebar: "#FFF7ED", // Blanc légèrement orange
    colorTextContent: "#2C261A", // Noir légèrement orange
  },
  {
    name: "emerald",
    colorHeader: "#065F46", // Émeraude profond
    colorSidebar: "#34D399", // Émeraude vif
    colorContent: "#FFFFFF",
    colorTextHeader: "#FFFFFF", // Blanc
    colorTextSidebar: "#ECFDF5", // Blanc légèrement émeraude
    colorTextContent: "#1A2C24", // Noir légèrement émeraude
  },
  {
    name: "cyan",
    colorHeader: "#0EA5E9", // Cyan profond
    colorSidebar: "#38BDF8", // Cyan vif
    colorContent: "#FFFFFF",
    colorTextHeader: "#FFFFFF", // Blanc
    colorTextSidebar: "#F0F9FF", // Blanc légèrement cyan
    colorTextContent: "#1A2C2C", // Noir légèrement cyan
  },
  {
    name: "pink",
    colorHeader: "#BE185D", // Rose profond
    colorSidebar: "#F43F5E", // Rose vif
    colorContent: "#FFFFFF",
    colorTextHeader: "#FFFFFF", // Blanc
    colorTextSidebar: "#FFF0F6", // Blanc légèrement rose
    colorTextContent: "#2C1A24", // Noir légèrement rose
  },
  {
    name: "brown",
    colorHeader: "#78350F", // Marron profond
    colorSidebar: "#F59E0B", // Jaune doré vif
    colorContent: "#FFFFFF",
    colorTextHeader: "#FFFFFF", // Blanc
    colorTextSidebar: "#FFFBEA", // Blanc légèrement doré
    colorTextContent: "#2C211A", // Noir légèrement marron
  },
  {
    name: "blueNight",
    colorHeader: "#111827", // Bleu nuit
    colorSidebar: "#1E40AF", // Bleu royal
    colorContent: "#FFFFFF",
    colorTextHeader: "#FFFFFF", // Blanc
    colorTextSidebar: "#E5E7EB", // Blanc légèrement gris
    colorTextContent: "#1C1C2C", // Noir légèrement bleu
  },
];

const getColorTheme = (color) => {

  return colorsTheme.find((item) => item.name === color);
};

const ClassiqueCopy = ({ colorSelected, infoSheetGlobal, options, isLoadingMyGoal, isLoadingInfo,
  data, handleGetContentRef

}) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [pages, setPages] = useState([]);
  const [heightElementContent, setHeightElementContent] = useState(0);
  const currentDate = new Date();

  // Refs
  const contentRefs = useRef([]);
  const contentHeaderRef = useRef();
  const contentMainRef = useRef();

  // Sidebar ref
  const profileImageRef = useRef(null);
  const studentInfoRef = useRef(null);
  const criteriaRef = useRef(null);
  const softSkillsRef = useRef(null);
  const languagesRef = useRef(null);
  const codingSkillsRef = useRef(null);
  const hobbiesRef = useRef(null);
  const softwareSkillsRef = useRef(null);
  const achievementsRef = useRef(null);

  // Main ref
  const experiencesRef = useRef(null);
  const formationsRef = useRef(null);
  const certificationsRef = useRef(null);
  const skillsProRef = useRef(null);

  useEffect(() => {
    let elementsContentHeight = 0;
    if (contentHeaderRef.current) {
      elementsContentHeight += contentHeaderRef.current.clientHeight;
      elementsContentHeight += 40; // Padding 20 haut et bas
    }

    if (contentMainRef.current) {
      elementsContentHeight += contentMainRef.current.clientHeight;
      elementsContentHeight += 40; // Padding 20 haut et bas
    }

    setHeightElementContent(elementsContentHeight);

  }, [options]);

  const getLabel = (label) => {
    switch (label) {
      case 'Trouver un stage':
        return 'de stage';
      case 'Trouver une alternance':
        return "d'alternance";
      case 'Trouver une formation':
        return null;
      case 'Trouver une formation et un stage':
        return "de stage";
      case 'Trouver une formation et une alternance':
        return "d'alternance";
      default:
        return null;
    }
  };

  const WIDTH_SIDEBAR = 200;
  const WIDTH_PROFIL_PICTURE = 125;

  const infoSheet = {
    widthSidebar: WIDTH_SIDEBAR,
    widthSidebarWithMargin: 150 + 30,
    marginLeftSidebar: 20,
    paddingHorizontal: 30,
    paddingHorizontalPicture: WIDTH_SIDEBAR - WIDTH_PROFIL_PICTURE,
    marginTopSidebar: 20,
    heightHeader: 180,
    paddingLeftHeader: 20,
    paddingTopHeader: 20,
    widthProfilPicture: WIDTH_PROFIL_PICTURE,
    widthSidebarTotal: 200 + 30 + 125,
    experienceWidth: 550,
    colorPrimary: getColorTheme(colorSelected).colorHeader,
    colorSecondary: getColorTheme(colorSelected).colorSidebar,
    dividerColor: getColorTheme(colorSelected).colorTextContent,
  }

  const htmlStaticStyle = {
    ligne: (index) => ({
      width: '100%',
      height: '10px',
      backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#fff',
    }),
    sectionSidebar: {
      margin: "20px",
    },
    studentInfo: {
      paddingLeft: infoSheet.paddingHorizontal / 2,
      paddingRight: infoSheet.paddingHorizontal / 2,
      marginBottom: "30px"
    },
    containerChoiseInSettingSidebar: {
      display: 'flex',
      flexDirection: 'column',
    },
    titleSettingSidebar: {
      fontFamily: 'Montserrat',
      color: '#152652',
      lineHeight: '100%',
      fontWeight: 600,
      fontSize: '15px', // 15px
      '@media only screen and (max-width: 1543px)': { fontSize: '14.5px' }, // 14.5px
      '@media only screen and (max-width: 1279px)': { fontSize: '14px' }, // 14px
      '@media only screen and (max-width: 810px)': { fontSize: '13.5px' }, // 13.5px
      '@media only screen and (max-width: 390px)': { fontSize: '13px' }, // 13px
      margin: 0,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      transition: 'all 0.2s',
    },
    subTitleSettingSidebar: {
      fontFamily: 'Roboto',
      color: '#5D75A8',
      fontWeight: 400,
      fontSize: '14px', // 15px
      '@media only screen and (max-width: 1543px)': { fontSize: '13.5px' },
      '@media only screen and (max-width: 1279px)': { fontSize: '13px' },
      '@media only screen and (max-width: 810px)': { fontSize: '12.5px' },
      '@media only screen and (max-width: 390px)': { fontSize: '12px' },
    },
    mergeStyle: (...styles) => {
      return styles.reduce((acc, style) => {
        return { ...acc, ...style };
      }, {});
    },
    createWithLinkpick: {
      position: 'absolute',
      bottom: '10px',
      right: '10px',
      display: 'flex',
    },
    imgLinkpick: {
      width: '20px',
      height: '20px',
    },
    colorChoiceContainer: {
      display: 'flex',
      gap: '10px',
      flexWrap: 'wrap',
      // margin: "15px"
    },
    dropdownIcon: {
      cursor: 'pointer',
    },
    textInHeader: {
      color: getColorTheme(colorSelected).colorTextSecondarySidebar,
    },
    title: {
      margin: 0,
      marginBottom: "10px",
      fontSize: "17px",
      fontFamily: "Montserrat",
      color: infoSheet.colorPrimary,
      lineHeight: "100%",
    },
    primary: {
      color: infoSheet.colorPrimary,
    },
    qrCodeStudent: {
      position: 'absolute',
      top: '10px',
      right: '10px',
      width: '80px',
      height: '80px',
    },
    name: {
      fontSize: "25px",
    },
    resetStyleTitle: {
      margin: 0,
      marginBottom: "10px",
      padding: 0,
      fontFamily: "Montserrat",
      // color:
    },
    titleSidebar: {
      margin: 0,
      marginBottom: "0px",
      padding: 0,
      fontFamily: "Montserrat",
      fontSize: "14px",
      fontWeight: 600,
      color: getColorTheme(colorSelected).colorTextHeader,
    },
    primary: {
      color: infoSheet.colorPrimary,
    },
    resetStyleText: {
      margin: 0,
      padding: 0,
      fontFamily: "Roboto",
      textDecoration: "none",
      fontSize: "12px",
      color: getColorTheme(colorSelected).colorTextSecondarySidebar ? getColorTheme(colorSelected).colorTextSecondarySidebar : "#fff",
    },
    textSidebar: {
      color: `${getColorTheme(colorSelected).colorTextSidebar}`,
    },
    textContent: {
      color: getColorTheme(colorSelected).colorTextContent,
    },
    textFit: {
      width: "fit-content",
    },
    resetStyleTextInContent: {
      margin: 0,
      padding: 0,
      fontFamily: "Roboto",
      textDecoration: "none",
      fontSize: "12px",
    },
    textLink: {
      textDecoration: "underline",
      color: "rgb(21, 38, 50);"
    },
    smallIcon: {
      // color: getColorTheme(colorSelected).colorTextHeader,
      fill: getColorTheme(colorSelected).colorTextHeader,
      marginRight: '4.5px',
      width: 20,
      height: 20,
      opacity: 0.8,
    },
    header: {
      // backgroundColor: infoSheetGlobal.colorPrimary,
      paddingTop: `${infoSheet.paddingTopHeader}px`,
      // padding: `${infoSheet.paddingTopHeader}px ${infoSheet.paddingTopHeader}px ${infoSheet.paddingTopHeader}px ${(infoSheet.widthSidebar + infoSheet.marginLeftSidebar + infoSheet.paddingLeftHeader) - 40}px`,
      color: infoSheetGlobal.textHeaderDark ? "#000" : "#fff",
      display: "flex",
      flexDirection: "row",
    },
    leftHeader: {
      position: "relative",
    },
    rightHeader: {
      marginLeft: "20px",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
    },
    profilePicture: {
      width: `${infoSheet.widthProfilPicture}px`,
      height: `${infoSheet.widthProfilPicture}px`,
      borderRadius: 0,
      marginLeft: `${infoSheet.paddingHorizontalPicture / 2}px`,
      marginRight: `${infoSheet.paddingHorizontalPicture / 2}px`,
      marginTop: `${infoSheet.paddingHorizontalPicture / 2}px`,
      paddingBottom: "6px",
    },
    containerCoordonate: {
      display: 'flex',
      flexDirection: 'column',
      width: `${infoSheetGlobal.width * 0.5}px`,
      marginBottom: '10px',
    },
    logoAndLabel: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    coordonate: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      // marginBottom: '10px',
    },
    presentation: {
      marginBottom: "10px"
    },
    qrcode: {
      marginTop: "20px",
      width: "50px",
      height: "50px",
    },
    sidebar: {
      width: `${infoSheet.widthSidebar}px`,
      height: "1123px",
      backgroundColor: infoSheet.colorSecondary,
      zIndex: 2,
      // overflowY: "hidden",
    },
    divider(width, height, color) {
      return {
        width: `${width}px`,
        height: `${height}px`,
        backgroundColor: color ? color : "#C0D9FF",
        // margin: "6px 0",
      };
    },
    sectionSidebarItems: {
      display: "flex",
      flexDirection: "column",
      gap: "4px",
      marginLeft: `${infoSheet.paddingHorizontal / 2}px`,
      marginRight: `${infoSheet.paddingHorizontal / 2}px`,
      paddingBottom: "6px",

    },
    transportContainer: {
      display: "flex",
    },
    contentCv: {
      // padding: `${infoSheet.paddingTopHeader}px ${infoSheet.paddingTopHeader}px ${infoSheet.paddingTopHeader}px ${(infoSheet.widthSidebar + infoSheet.marginLeftSidebar + infoSheet.paddingLeftHeader) - 40}px`,
      display: "flex",
      flexDirection: "column",
      paddingLeft: `50px`,
      paddingTop: `25px`,
    },
    underlineParent: {
      position: "relative",
      width: "fit-content",
    },
    underline: {
      position: "absolute",
      bottom: "-3px",
      left: "0",
      width: "100%",
      height: "2px",
      backgroundColor: infoSheetGlobal.colorPrimary,
    },
    experiences: {
      width: `${infoSheet.experienceWidth}px`,
      paddingTop: "10px",
      paddingBottom: "10px",
    },
    oneExperience: {
      marginBottom: "14px",
    },
    experienceTitleAndDate: {
      display: "flex",
      justifyContent: "space-between",
    },
    titleInExperience: {
      margin: 0,
      fontWeight: 600,
      fontSize: "15px",
      fontFamily: "Montserrat",
    },
    descriptionInExperience: {
      margin: 0,
      fontWeight: 500,
      fontSize: "14px",
      fontFamily: "Montserrat",
    },
    experiencesCompanyAndCity: {
      transform: "translateY(-4px)",
    },
    container: {
      position: "relative",
      width: "794px", // Largeur A4
      minHeight: "1123px", // Hauteur A4
      backgroundColor: "#ffffff",
      boxShadow: "0 0 5px rgba(0,0,0,0.2)",
      overflow: "hidden",
      display: "flex",
    },
    horizontalLine: {
      position: "absolute",
      width: "100%",
      height: "1px",
      backgroundColor: "#ddd",
    },
    verticalLine: {
      position: "absolute",
      height: "100%",
      width: "1px",
      backgroundColor: "#ddd",
    },
    // 
    styleTitleSection: {
      color: infoSheet.colorPrimary,
      marginBottom: "10px"
    },
    // metier en anglais
    experience: {
      fontFamily: "Montserrat",
      margin: 0,
      marginBottom: "6px",
      marginLeft: "20px"
    },
    experienceDate: {
      fontFamily: "Montserrat",
      margin: 0,
      color: "gray",
      fontWeight: 400,
      marginLeft: "20px"
    }
  }

  const calculateElementHeightWithMargins = (ref) => {
    if (!ref?.current) return 0;
    const style = window.getComputedStyle(ref.current);
    // const marginTop = parseFloat(style.marginTop) || 0;
    // const marginBottom = parseFloat(style.marginBottom) || 0;
    const height = ref.current.offsetHeight || 0;
    return height + 6;
  };

  const calculateHeight = () => ({
    profileImage: calculateElementHeightWithMargins(profileImageRef),
    studentInfo: calculateElementHeightWithMargins(studentInfoRef),
    criteria: calculateElementHeightWithMargins(criteriaRef),
    softSkills: calculateElementHeightWithMargins(softSkillsRef),
    languages: calculateElementHeightWithMargins(languagesRef),
    codingSkills: calculateElementHeightWithMargins(codingSkillsRef),
    hobbies: calculateElementHeightWithMargins(hobbiesRef),
    softwareSkills: calculateElementHeightWithMargins(softwareSkillsRef),
    achievements: calculateElementHeightWithMargins(achievementsRef),
  });

  const createSidebarElements = (info, options, htmlStaticStyle) => {
    const createSidebarElement = (id, heightKey, content, ref) => {
      return {
        id,
        height: calculateHeight()[heightKey],
        content: <div ref={ref}>{content}</div>,
      };
    };

    const newSidebarElements = [];

    if (data.profileImageUrl) {
      newSidebarElements.push(
        createSidebarElement(
          'profileImage',
          'profileImage',
          <div style={{ marginBottom: '6px' }}>
            <img
              width={htmlStaticStyle.profilePicture.width}
              height={htmlStaticStyle.profilePicture.height}
              style={htmlStaticStyle.profilePicture}
              src={data.profileImageUrl}
            />
          </div>,
          profileImageRef
        )
      );
    } else {
      newSidebarElements.push(
        createSidebarElement(
          'profileAvatar',
          'profileImage',
          <Avatar style={htmlStaticStyle.profilePicture}>
            {info?.firstname?.substr(0, 1) + info?.lastname?.substr(0, 1)}
          </Avatar>,
          profileImageRef
        )
      );
    }

    newSidebarElements.push(
      createSidebarElement(
        'studentInfo',
        'studentInfo',
        <div style={htmlStaticStyle.studentInfo}>
          <div style={htmlStaticStyle.logoAndLabel}>
            <CakeIcon style={htmlStaticStyle.smallIcon} />
            <p style={htmlStaticStyle.mergeStyle(htmlStaticStyle.resetStyleText, { height: '14px' })}>{differenceInYears(currentDate, new Date(info?.birthDate))} ans</p>
          </div>
          <div style={htmlStaticStyle.logoAndLabel}>
            <PhoneIcon style={htmlStaticStyle.smallIcon} />
            <a
              style={htmlStaticStyle.mergeStyle(
                htmlStaticStyle.resetStyleText
                , {
                  height: '14px',
                }
              )}
            >
              {formatPhoneNumber(info?.phone)}
            </a>
          </div>
          <div style={htmlStaticStyle.logoAndLabel}>
            <MailIcon style={htmlStaticStyle.smallIcon} />
            <a
              href={`mailto:${info?.email}`}
              style={htmlStaticStyle.mergeStyle(
                htmlStaticStyle.resetStyleText,
                {
                  height: '14px'
                }
              )}
            >
              {info?.email}
            </a>
          </div>
          <div style={htmlStaticStyle.logoAndLabel}>
            <LocationIcon style={htmlStaticStyle.smallIcon} />
            <p style={htmlStaticStyle.mergeStyle(htmlStaticStyle.resetStyleText, { height: '14px' })}>{info?.address?.label}</p>
          </div>
        </div>,
        studentInfoRef
      ))

    if (info?.desiredContractLength) {
      newSidebarElements.push(
        createSidebarElement(
          'criteria',
          'criteria',
          <>
            <div style={htmlStaticStyle.sectionSidebarItems}>
              <h3 style={htmlStaticStyle.titleSidebar}>Critères de recherche</h3>
              {getLabel(data.myGoal?.label) && info?.desiredContractLength && (
                <p style={htmlStaticStyle.resetStyleText}>
                  <span
                    style={htmlStaticStyle.mergeStyle(
                      htmlStaticStyle.resetStyleText,
                      htmlStaticStyle.textSidebar
                    )}
                  >
                    {`${info?.desiredContractLength} mois ${getLabel(data.myGoal?.label)}`}
                  </span>
                </p>
              )}
              {/* {info?.jobDomain?.label && (
                <p style={htmlStaticStyle.resetStyleText}>
                  <span
                    style={htmlStaticStyle.mergeStyle(
                      htmlStaticStyle.resetStyleText,
                      htmlStaticStyle.textSidebar
                    )}
                  >
                    {info?.jobDomain?.label}
                  </span>
                </p>
              )} */}
              {info.jobs.length > 0 && info.jobs.map((item) => (
                <p style={htmlStaticStyle.mergeStyle(
                  htmlStaticStyle.resetStyleText,
                  htmlStaticStyle.textSidebar
                )} key={item.id}>{item.label}</p>
              ))}
            </div>
            {/* <div style={htmlStaticStyle.divider(infoSheet.widthSidebarWithMargin, 2)}></div> */}
          </>,
          criteriaRef
        )
      );
    }

    const sections = [
      {
        id: 'softSkills',
        heightKey: 'softSkills',
        items: options?.softSkillsSelected,
        title: 'Compétences perso',
        ref: softSkillsRef,
      },
      {
        id: 'languages',
        heightKey: 'languages',
        items: options?.skillsLanguageSelected,
        title: 'Langues',
        ref: languagesRef,
      },
      {
        id: 'codingSkills',
        heightKey: 'codingSkills',
        items: options?.codingSkillsSelected,
        title: 'Langages de Programmation',
        ref: codingSkillsRef,
      },
      {
        id: 'hobbies',
        heightKey: 'hobbies',
        items: options?.hobbiesSelected,
        title: "Centres d'intérêt",
        ref: hobbiesRef,
      },
      {
        id: 'softwareSkills',
        heightKey: 'softwareSkills',
        items: options?.softwareSkillsSelected,
        title: 'Logiciels',
        ref: softwareSkillsRef,
      },
      {
        id: 'achievements',
        heightKey: 'achievements',
        items: options?.achievementsSelected,
        title: 'Réalisations',
        ref: achievementsRef,
        isLink: true,
      },
    ];

    sections.forEach(({ id, heightKey, items, title, ref, isLink }) => {
      if (items?.length > 0) {
        newSidebarElements.push(
          createSidebarElement(
            id,
            heightKey,
            <>
              <div style={htmlStaticStyle.sectionSidebarItems}>
                <h3 style={htmlStaticStyle.titleSidebar}>{title}</h3>
                {items.map(({ id, label, path }) => (
                  isLink ? (
                    <a
                      key={id}
                      href={path}
                      style={htmlStaticStyle.mergeStyle(
                        htmlStaticStyle.resetStyleText,
                        {
                          color: getColorTheme(colorSelected).colorTextSidebar,
                          textDecoration: "underline",
                        }
                      )}
                    >
                      {label}
                    </a>
                  ) : (
                    <p
                      key={id}
                      style={htmlStaticStyle.mergeStyle(
                        htmlStaticStyle.resetStyleText,
                        htmlStaticStyle.textSidebar
                      )}
                    >
                      {label}
                    </p>
                  )
                ))}
              </div>
              {/* <div style={htmlStaticStyle.divider(infoSheet.widthSidebarWithMargin, 2)}></div> */}
            </>,
            ref
          )
        );
      }
    });

    return newSidebarElements;
  };

  const createMainContentElements = (
    info,
    options,
    htmlStaticStyle,
    experienceWidth,
    colorSecondary
  ) => {
    const elements = [];
    const mainElements = [];

    const createSection = (id, title, items, mapFn, sortFn, ref) => {
      if (items.length > 0) {
        const sortedItems = sortFn ? items.sort(sortFn) : items;

        const sectionContent = (
          <div ref={ref} style={{
            marginBottom: "20px",
            position: "relative",
            color: getColorTheme(colorSelected).colorTextContent
          }}>
            <div style={{}}>
              <h3
                style={htmlStaticStyle.styleTitleSection}
              >
                {title}
              </h3>
            </div>
            {sortedItems.map(mapFn)}
            <div
              style={{
                position: "absolute",
                top: "30px", // taille du titre + margin bottom - 10px
                left: "0px",
                width: "4px",
                height: "calc(100% - 24.4px)",
                backgroundColor: infoSheet.colorPrimary,
              }}
            />
          </div>
        );

        mainElements.push({
          id,
          ref,
          height: null,
          content: sectionContent,
        });
      }
    };

    createSection(
      "workExperience",
      "Expériences Professionnelles",
      options?.workExperiencesSelected,
      ({ id, label, label_man, label_woman, startDate, endDate, company, city }) => {
        const labelOfGender =
          info?.gender === "FEMALE" && label_woman
            ? label_woman
            : info?.gender === "MALE" && label_man
              ? label_man
              : label;
        return (
          <div
            key={id}
            style={{ margin: "10px 0" }}
          >
            <div
              style={{
                position: "relative",
              }}
            >
              <h4
                style={htmlStaticStyle.experience}
              >
                {labelOfGender}
              </h4>
              <div
                style={{
                  position: "absolute",
                  top: "4.5px",
                  left: "-2.5px",
                  width: "10px",
                  height: "10px",
                  backgroundColor: infoSheet.colorPrimary,
                  clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                  transform: "rotate(45deg)",
                  zIndex: 2
                }}
              />
              <h5
                style={htmlStaticStyle.experienceDate}
              >
                {
                  endDate ? (
                    `De ${format(new Date(startDate), "MMMM yyyy", { locale: fr })} à ${format(new Date(endDate), "MMMM yyyy", { locale: fr })}`
                  ) : (
                    <>
                      Depuis {format(new Date(startDate), "MMMM yyyy", { locale: fr })}{" "}
                      <span style={{ color: infoSheet.colorPrimary }}>{company}</span>
                      {company && city && " "}
                      {city}
                    </>
                  )
                }

              </h5>
            </div>
            <p
              style={htmlStaticStyle.mergeStyle(
                htmlStaticStyle.resetStyleTextInContent,
                htmlStaticStyle.experiencesCompanyAndCity,
                htmlStaticStyle.textContent
              )}
            >

            </p>
          </div >
        );
      },
      (a, b) => new Date(b.startDate) - new Date(a.startDate),
      experiencesRef
    );

    // Trainings
    createSection(
      "trainings",
      "Formations",
      options?.trainingsSelected,
      ({ id, label, startDate, endDate, school, city }) => (
        <div
          key={id}
          style={{ margin: "10px 0" }}
        >
          <div>
            <div
              style={{
                position: "relative",
              }}
            >
              <h4
                style={htmlStaticStyle.experience}
              >
                {label}
              </h4>

              <h5
                style={htmlStaticStyle.experienceDate}
              >
                {
                  endDate ? (
                    <>
                      De {format(new Date(startDate), "MMMM yyyy", { locale: fr })} à {format(new Date(endDate), "MMMM yyyy", { locale: fr })}{" "}
                      <span style={{ color: infoSheet.colorPrimary }}>{school}</span>
                      {school && city && " "}
                      {city}
                    </>
                  ) : (
                    <>
                      Depuis {format(new Date(startDate), "MMMM yyyy", { locale: fr })}{" "}
                      <span style={{ color: infoSheet.colorPrimary }}>{school}</span>
                      {school && city && " "}
                      {city}
                    </>
                  )
                }

              </h5>

              <div
                style={{
                  position: "absolute",
                  top: "4.5px",
                  left: "-2.5px",
                  width: "10px",
                  height: "10px",
                  backgroundColor: infoSheet.colorPrimary,
                  clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                  transform: "rotate(45deg)",
                  zIndex: 2
                }}
              />
            </div>

          </div>

        </div>
      ),
      (a, b) => new Date(b.startDate) - new Date(a.startDate),
      formationsRef
    );


    createSection(
      "certifications",
      "Certifications",
      options?.certificationsSelected,
      ({ id, label, issueDate, expirationDate, school, city }) => (
        <div
          key={id}
          style={{ margin: "10px 0" }}
        >
          <div>
            <div
              style={{
                position: "relative",
              }}
            >
              <h4
                style={htmlStaticStyle.experience}
              >
                {label}
              </h4>
              <h5
                style={htmlStaticStyle.experienceDate}
              >
                <>
                  Obtenu en {format(new Date(issueDate), "MMMM yyyy", { locale: fr })}{" "}
                  <span style={{ color: getColorTheme(colorSelected).colorTextHeader }}>{school}</span>
                  {school && city && " "}
                  {city}
                </>
                {/* {expirationDate && `, valide jusqu'à ${format(new Date(expirationDate), "MMMM yyyy", { locale: fr })}`} */}
              </h5>
              <div
                style={{
                  position: "absolute",
                  top: "4.5px",
                  left: "-2.5px",
                  width: "10px",
                  height: "10px",
                  backgroundColor: infoSheet.colorPrimary,
                  clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                  transform: "rotate(45deg)",
                  zIndex: 2
                }}
              />
            </div>
          </div>
          {/* <p
            style={htmlStaticStyle.mergeStyle(
              htmlStaticStyle.resetStyleTextInContent,
              htmlStaticStyle.experiencesCompanyAndCity,
              htmlStaticStyle.textContent
            )}
          >
            {school}
            {school && city && ", "}
            {city}
          </p> */}
        </div>
      ),
      (a, b) => new Date(b.issueDate) - new Date(a.issueDate),
      certificationsRef
    );


    createSection(
      "skillsPro",
      "Compétences pro.",
      Object.entries(
        (options?.skillsProSelected || []).reduce((acc, { category, label }) => {
          const categoryLabel = category.label;
          if (!acc[categoryLabel]) {
            acc[categoryLabel] = [];
          }
          acc[categoryLabel].push(label);
          return acc;
        }, {})
      ),
      ([categoryLabel, labels], index) => (
        <div
          key={index}
          style={{ margin: "10px 0" }}
        >
          <div
            style={{
              position: "relative",
            }}
          >
            <h4
              style={htmlStaticStyle.experience}
            >
              {categoryLabel}
            </h4>
            <div
              style={{
                marginLeft: "20px"
              }}
            >
              {labels.map((label, subIndex) => (
                <p
                  key={subIndex}
                  style={htmlStaticStyle.mergeStyle(
                    htmlStaticStyle.resetStyleTextInContent,
                    htmlStaticStyle.textContent
                  )}
                >
                  {label}
                </p>
              ))
              }

              <div
                style={{
                  position: "absolute",
                  top: "4.5px",
                  left: "-2.5px",
                  width: "10px",
                  height: "10px",
                  backgroundColor: infoSheet.colorPrimary,
                  clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                  transform: "rotate(45deg)",
                  zIndex: 2
                }}
              />
            </div>
          </div>
        </div >
      ),
      null,
      skillsProRef
    );

    return mainElements;
  };

  const refreshCv = async () => {
    const maxHeight = 1103;
    let pages = [{ maxHeight, sidebar: [], main: [] }];
    let totalSidebarHeight = 0;
    let totalMainHeight = 0;

    const sidebarElements = createSidebarElements(data.info, options, htmlStaticStyle);
    for (const elem of sidebarElements) {
      const height = await calculateElementHeightWithMargins(
        {
          profileImage: profileImageRef,
          studentInfo: studentInfoRef,
          criteria: criteriaRef,
          softSkills: softSkillsRef,
          languages: languagesRef,
          codingSkills: codingSkillsRef,
          hobbies: hobbiesRef,
          softwareSkills: softwareSkillsRef,
          achievements: achievementsRef,
        }[elem.id]
      );

      const newElement = { id: elem.id, height, content: elem.content };

      if (totalSidebarHeight + height > maxHeight) {
        pages.push({ maxHeight, sidebar: [newElement], main: [] });
        totalSidebarHeight = height;
      } else {
        pages[pages.length - 1].sidebar.push(newElement);
        totalSidebarHeight += height;
      }
    }
    let currentMainPageIndex = 0;

    const mainContentElements = createMainContentElements(
      data.info,
      options,
      htmlStaticStyle,
      infoSheet.experienceWidth,
      infoSheetGlobal.colorSecondary
    );

    for (const elem of mainContentElements) {

      const height = await calculateElementHeightWithMargins(elem.ref);

      const newElement = { id: elem.id, height, content: elem.content };

      while (pages.length <= currentMainPageIndex) {
        pages.push({ maxHeight, sidebar: [], main: [] });
      }

      if (totalMainHeight + height > maxHeight) {
        currentMainPageIndex++;
        if (pages.length <= currentMainPageIndex) {
          pages.push({ maxHeight, sidebar: [], main: [] });
        }
        pages[currentMainPageIndex].main.push(newElement);
        totalMainHeight = height;
      } else {
        pages[currentMainPageIndex].main.push(newElement);
        totalMainHeight += height;
      }
    }


    setPages(pages);
  };

  useEffect(() => {
    refreshCv();
    handleGetContentRef(contentRefs);
  }, [options, colorSelected, isLoadingInfo, isLoadingMyGoal]);

  return (
    <div className={classes.cvContainer}>
      <div className={classes.container}>
        <div style={{ height: `${infoSheetGlobal.height}px` }} className={classes.containerAbsolute}>
          {pages.map((page, pageIndex) => (
            <div
              ref={(el) => (contentRefs.current[pageIndex] = el)}
              key={pageIndex}
              id="height-forbackend"
              style={{ ...htmlStaticStyle.container, marginBottom: "20px" }}
            >
              <div style={htmlStaticStyle.sidebar}>
                {page.sidebar.map((element, index) => (
                  <div key={index} style={{ marginBottom: "6px" }}>
                    {element.content}
                  </div>
                ))}
              </div>

              <div style={htmlStaticStyle.contentCv}>
                {pageIndex === 0 && (
                  <ClassiqueCopyHeader htmlStaticStyle={htmlStaticStyle} transportsSelected={options?.transportsSelected} contentHeaderRef={contentHeaderRef} info={data.info} />
                )}
                {page.main.map((element, index) => (
                  <div key={index}>
                    {element.content}
                  </div>
                ))}
              </div>

              <div style={htmlStaticStyle.createWithLinkpick}>
                <img
                  style={htmlStaticStyle.imgLinkpick}
                  src="https://ucarecdn.com/7991c37d-aa1b-412d-9fc6-4154da13a925/-/resize/200x200/"
                  alt="Linkpick"
                />
                <a
                  style={htmlStaticStyle.mergeStyle(htmlStaticStyle.textContent, htmlStaticStyle.textLink)}
                  href="https://linkpick.fr/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Créé avec Linkpick
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

const styles = () => ({
  cvContainer: {
    overflowY: 'scroll',
    width: getWindowsSize().widthScreen * percentage.percentageContent,
    // backgroundColor: 'blue'
  },
  container: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },
  containerAbsolute: {
    alignItems: 'center',
    display: 'flex',
    margin: '20px 0px',
    flexDirection: 'column',
    gap: '20px',
  },
});

export default ClassiqueCopy;